/**
 * Listens to i18n.languageChanged and invalidates all React Query caches.
 *
 * Many backend responses (e.g. badm rule names + descriptions) are localized
 * server-side via Accept-Language. Without this, switching language in the UI
 * would still show stale translations until the user manually navigated away.
 */
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useQueryClient } from '@tanstack/react-query'

export function InvalidateOnLanguageChange() {
  const { i18n } = useTranslation()
  const qc = useQueryClient()

  useEffect(() => {
    const handler = () => {
      qc.invalidateQueries()
    }
    i18n.on('languageChanged', handler)
    return () => {
      i18n.off('languageChanged', handler)
    }
  }, [i18n, qc])

  return null
}
